import { Component, Input } from '@angular/core';
import { ControlValueAccessorModel, getProvider } from '../../models/control-value-accessor.model';

import { DropdownOptionModel } from '../../models/dropdown-option.model';

@Component({
    selector: 'agpr-tabs-toggle',
    templateUrl: './tabs-toggle.component.html',
    styleUrls: ['./tabs-toggle.component.scss'],
    providers: [getProvider(TabsToggleComponent)],
    standalone: false
})
export class TabsToggleComponent extends ControlValueAccessorModel<any> {

    @Input() id: string = 'tabsToggle';
    @Input() options: DropdownOptionModel[];
    @Input() clickToConfirm: boolean = true;

    value: any;
    focused: boolean;

    constructor() {
        super();
    }

    writeValue(value: any): void {
        this.value = value;
    }

    onRadioChanged(value: any): void {
        this.onModelChange(this.value);
    }

    focusToggle(focus: boolean): void {
        this.focused = focus;
    }
}
